import React from 'react'
import styled from 'styled-components'
import { TogglePasswordButton } from './ToggleShowPasswordButton'
import { Tooltip } from '../Tooltip'
import { ReactComponent as CopyIcon } from '@sketch/icons/rectangles-2-17'
import { ReactComponent as RefreshIcon } from '@sketch/icons/arrow-counterclockwise-17'

const CopyButton = styled(TogglePasswordButton)`
  /* The right padding on StyledPasswordInput and PreviewPasswordInput is calculated
    based on the size and right position of this button. Update those accordingly if
    one of them changes here. */
  right: 48px;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  &:active {
    color: ${({ theme }) => theme.colors.sketch.A};
    background-color: ${({ theme }) => theme.colors.sketch.F};
    border-radius: 6px;
  }
`

const GenerateButton = styled(CopyButton)`
  /* The right padding on StyledPasswordInput and PreviewPasswordInput is calculated
    based on the size and right position of this button. Update those accordingly if
    one of them changes here. */
  right: 96px;
  top: 21px;
`

interface ToggleCopyPasswordButtonProps {
  onClick: () => void
  disabled?: boolean
}

export const ToggleCopyPasswordButton: React.FCC<
  ToggleCopyPasswordButtonProps
> = ({ onClick, disabled = false }: ToggleCopyPasswordButtonProps) => {
  return (
    <Tooltip content="Copy password" placement="bottom">
      {/* Use render prop pattern to attach ref directly to button (not a wrapper div)
          so tooltip positions relative to the absolutely positioned button */}
      {props => (
        <CopyButton
          data-testid="copy-icon"
          onClick={onClick}
          disabled={disabled}
          showPassword={false}
          {...props}
        >
          <CopyIcon
            width={17}
            height={17}
            focusable={false}
            aria-hidden={true}
          />
        </CopyButton>
      )}
    </Tooltip>
  )
}

export const ToggleGeneratePasswordButton: React.FCC<
  ToggleCopyPasswordButtonProps
> = ({ onClick, disabled = false }: ToggleCopyPasswordButtonProps) => {
  return (
    <Tooltip content="Generate new password" placement="bottom">
      {/* Use render prop pattern to attach ref directly to button (not a wrapper div)
          so tooltip positions relative to the absolutely positioned button */}
      {props => (
        <GenerateButton
          data-testid="refresh-icon"
          onClick={onClick}
          disabled={disabled}
          showPassword={false}
          {...props}
        >
          <RefreshIcon
            width={17}
            height={17}
            focusable={false}
            aria-hidden={true}
          />
        </GenerateButton>
      )}
    </Tooltip>
  )
}
